import React from 'react';
import styled from 'styled-components';
import { url } from 'js/services/Network';
import { Link as ReachLink } from '@reach/router';

const Container = styled.div`
  text-align: right;
  margin: -1rem 0 1rem;
`;

const Link = styled(ReachLink)`
  color: #999;
  font-size: 0.8rem;

  &:hover {
    color: black;
    text-decoration: underline;
  }
`;

export default () => (
  <Container>
    <Link to={url('forgot-password-page')}>Forgot your password?</Link>
  </Container>
);
